/**
 * CobrandTabs Styles
 *
 * Styled components for CobrandTabs molecule.
 * Uses Marriott global design tokens and variables for consistency.
 * Custom styles kept to minimum - leveraging global styles where possible.
 */

import styled from 'styled-components';
import { toRem, baseVariables } from '@marriott/mi-ui-library';

export const StyledTab = styled.div`
  /* Tab list container - horizontal scrollable */
  .m-standard-tab-list {
    overflow-x: auto;
    overflow-y: hidden;
    width: 100%;
    /* Use global color tokens for borders */
    border-bottom: ${toRem(1)} solid ${baseVariables.color['neutral40']};
    /* Smooth scrolling on mobile */
    -webkit-overflow-scrolling: touch;
    scrollbar-width: none; /* Firefox */

    &::-webkit-scrollbar {
      display: none; /* Chrome, Safari */
    }

    /* Individual tab list item */
    .m-standard-tab-list-item {
      min-width: ${toRem(74)};
      border-width: ${toRem(2)};
      display: inline-table;

      button {
        width: 100%;
        height: 100%;
        /* Ensure button fills parent for better click area */
        min-height: ${toRem(44)}; /* WCAG touch target size */
      }

      /* Add padding to all tabs except first */
      &:not(:first-child) {
        button {
          padding: 0 ${toRem(24)};
        }
      }
    }
  }

  /* Tab text styling - inactive state */
  .tabTitleText,
  .tab-subtitle {
    /* Use global color tokens */
    color: ${baseVariables.color['neutral40']};
    font-weight: 700;
    transition: color 0.2s ease-in-out;
  }

  /* Tab text styling - active state */
  .active {
    .tabTitleText,
    .tab-subtitle {
      /* Use global merchandising color for active tab */
      color: ${baseVariables.color['merch30']};
    }
  }

  /* Optional border for tab page container */
  .tabpage-border {
    /* Use global border radius and color tokens */
    border: ${toRem(1)} solid ${baseVariables.color['neutral30']};
    border-radius: var(--t-cards-border-radius, ${toRem(14)});
  }

  /* Tab page container */
  .tabpage-container {
    /* Add smooth transition for content changes */
    transition: opacity 0.2s ease-in-out;
  }
`;
